import { render, staticRenderFns } from "./UnstyledLink.vue?vue&type=template&id=0c9c3f7e&scoped=true"
import script from "./UnstyledLink.vue?vue&type=script&lang=js"
export * from "./UnstyledLink.vue?vue&type=script&lang=js"
import style0 from "./UnstyledLink.vue?vue&type=style&index=0&id=0c9c3f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c3f7e",
  null
  
)

export default component.exports